<template>
  <div class="change-answer-effect">
    <el-tooltip
      :disabled="!selectedContent"
      :visible-arrow="false"
      :content="selectedContent"
      placement="top"
    >
      <el-select
        id="question-select"
        v-close-on-zoom
        :value="state.effect.id"
        :placeholder="placeholder"
        :filterable="true"
        :default-first-option="true"
        class="question-select"
        :disabled="readonly"
        @input="(questionId) => selectQuestion(questionId)"
      >
        <el-option
          v-for="question in getDialogueItems(emitter.caseConf)"
          :key="question.id"
          :label="question.content.en"
          :value="question.id"
        />
      </el-select>
      <help-tooltip v-if="errors.length" type="error">
        <span v-for="error in errors" :key="error.message">{{
          error.message
        }}</span>
      </help-tooltip>
    </el-tooltip>
    <div>
      <el-input
        v-if="state.effect.id"
        id="answer-input"
        :value="state.effect.value"
        placeholder="Answer"
        :disabled="readonly"
        class="answer-input"
        @input="(answer) => updateAnswer(answer.trim())"
      />
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'change-answer-effect',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'effectType',
    'placeholder',
    'getDialogueItems',
  ],
  data() {
    return {
      state: {
        effect: {},
      },
    };
  },
  computed: {
    selectedContent() {
      const items = this.getDialogueItems(this.emitter.caseConf) || [];
      const item = items.find(i => i.id === this.state.effect.id);
      return get(item, 'content.en');
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        []
      ).filter((error) => error.metadata && error.metadata.scope === 'control');

      return uniqBy(errors, 'message');
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.update();
  },
  methods: {
    syncState() {
      this.state.effect = this.getData(this.ikey) || {};
    },
    selectQuestion(questionId) {
      this.state.effect.id = questionId;
      this.update();
    },
    updateAnswer(answer) {
      this.state.effect.value = answer;
      this.update();
    },
    update() {
      this.putData(this.ikey, { type: this.effectType, ...this.state.effect });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
</style>
